import { Box, Divider, FormControl, MenuItem, Select } from '@material-ui/core';
import Modal from '@material-ui/core/Modal';
import React, { useEffect, useState } from 'react';
import { useAuth } from '../../../../../../hooks/auth';
import { useToast } from '../../../../../../hooks/toast';
import api from '../../../../../../services/api';
import empresaApi from '../../../../../../services/empresaApi';
import { Subtitle } from '../../styles';
import {
  Container,
  ContainerButton,
  ContainerColor,
  ContainerColorDefault,
  CustomBox,
  ModalContainer,
  SaveColorButton,
} from './styles';

import { colorPalette } from './colorPalete';
import { SalesPage } from './page';

export interface IObjColor {
  title: 'custom' | 'default';
  primary: string;
  secondary: string;
}

const Customizations: React.FC = () => {
  const defaultColor = {
    title: 'default',
    primary: '#3f51b5',
    secondary: '#000',
  } as IObjColor;

  const [mainColor, setMainColor] = useState(defaultColor);
  const [testColor, setTestColor] = useState(defaultColor);
  const [grupoId, setGrupoId] = useState(0);
  const [modalOpen, setModalOpen] = useState(false);

  const { user } = useAuth();
  const { addToast } = useToast();

  const handleModalClose: () => void = () => {
    setModalOpen(false);
  };

  const saveNewColor = (color: IObjColor): void => {
    api
      .post(`/parametro`, {
        descricao: 'customizations',
        empresa_id: user.empresa_id,
        role: JSON.stringify(color),
      })
      .then((res) => {
        const role = JSON.parse(res.data.role);
        setMainColor(role);
        setTestColor(role);
        addToast({
          type: 'success',
          title: 'Alterado com sucesso',
        });
      })
      .catch((err) => {
        console.log(err);
        addToast({
          type: 'error',
          title: 'Erro na alteração. Tente novamente mais tarde.',
        });
      })
      .finally(() => {
        modalOpen && setModalOpen(false);
      });
  };

  const handleChange = (objColor: IObjColor): void => {
    setTestColor(objColor);
  };

  const isActiveCustomColor = (): void => {
    const prevState: IObjColor = { ...testColor, title: 'default' };
    saveNewColor(prevState);
  };

  useEffect(() => {
    empresaApi.getParametro(user.empresa_id, 'customizations').then((param) => {
      if (param) {
        setMainColor(JSON.parse(param.role));
        setTestColor(JSON.parse(param.role));
      }
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [grupoId]);

  useEffect(() => {
    setTestColor(mainColor);
  }, [modalOpen, mainColor]);

  useEffect(() => {
    async function loadData(): Promise<void> {
      const response = await api.get(`/empresa/${user.empresa_id}`);

      setGrupoId(response.data.grupo_id);
    }
    loadData();
  }, [user]);

  return (
    <Container>
      <CustomBox>
        <Subtitle>Cor</Subtitle>
        <Divider />
        <ContainerColorDefault>
          <div>
            <p>Cor principal:</p>
            <ContainerColor
              bgColor={
                mainColor.title === 'custom'
                  ? mainColor.primary
                  : defaultColor.primary
              }
            />
          </div>

          <div>
            <p>Cor secundária:</p>
            <ContainerColor
              bgColor={
                mainColor.title === 'custom'
                  ? mainColor.secondary
                  : defaultColor.secondary
              }
            />
          </div>
        </ContainerColorDefault>

        <Modal open={modalOpen} onClose={handleModalClose} closeAfterTransition>
          <Box
            style={{
              width: '100%',
              height: '100%',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
            }}
          >
            <ModalContainer>
              <h1>Alterar Cores</h1>
              <button
                type="button"
                className="closeModal"
                onClick={handleModalClose}
              >
                X
              </button>
              <Divider />

              <p>Cor principal:</p>
              <Box
                style={{
                  width: '100%',
                  display: 'flex',
                  gap: '10px',
                }}
              >
                <ContainerColor bgColor={testColor.primary} />
                <FormControl fullWidth size="small">
                  <Select
                    labelId="demo-simple-select-label"
                    id="demo-simple-select"
                    value={testColor.primary}
                    label="Paleta de cores"
                    onChange={(e) =>
                      handleChange({
                        ...testColor,
                        primary: e.target.value as string,
                      })
                    }
                  >
                    {colorPalette.map((color) => (
                      <MenuItem
                        value={color}
                        style={{
                          background: color,
                          height: '30px',
                          marginBottom: '3px',
                          borderRadius: '5px',
                        }}
                      />
                    ))}
                  </Select>
                </FormControl>
              </Box>

              <p>Cor secundária:</p>
              <Box
                style={{
                  width: '100%',
                  display: 'flex',
                  gap: '10px',
                  marginBottom: '30px',
                }}
              >
                <ContainerColor bgColor={testColor.secondary} />
                <FormControl fullWidth size="small">
                  <Select
                    labelId="demo-simple-select-label"
                    id="demo-simple-select"
                    value={testColor.secondary}
                    label="Paleta de cores"
                    onChange={(e) =>
                      handleChange({
                        ...testColor,
                        secondary: e.target.value as string,
                      })
                    }
                  >
                    {colorPalette.map((color) => (
                      <MenuItem
                        value={color}
                        style={{
                          background: color,
                          height: '30px',
                          marginBottom: '3px',
                          borderRadius: '5px',
                        }}
                      />
                    ))}
                  </Select>
                </FormControl>
              </Box>

              <SaveColorButton
                onClick={() => saveNewColor({ ...testColor, title: 'custom' })}
              >
                Salvar mudanças
              </SaveColorButton>
            </ModalContainer>
          </Box>
        </Modal>

        <ContainerButton>
          <SaveColorButton
            onClick={() => {
              setModalOpen(true);
            }}
          >
            Alterar Cores
          </SaveColorButton>

          <SaveColorButton
            onClick={isActiveCustomColor}
            className="redefinir-cores"
          >
            Redefinir
          </SaveColorButton>
        </ContainerButton>
      </CustomBox>
      <Box
        style={{
          flexGrow: 1,
        }}
      >
        <SalesPage grupoId={grupoId} color={mainColor} />
      </Box>
    </Container>
  );
};

export default Customizations;
